import React from 'react'
import { useSelector } from 'react-redux';
import { selectProducts } from '../../../features/products/productsSlice';
import SwiperProductsPage from '../../../components/SwiperProductsPage';

export const OnSaleProducts = () => {
    const products = useSelector(selectProducts);
    const onSaleProducts = products?.filter((product: any) => product.on_sale === true &&
        !product.slug.startsWith("mighty-bucks-gift-card-for-") && !product.slug.startsWith("gift-card")) || [];
    const onSaleProductIds = Array.from(new Set(onSaleProducts.map((product: any) => product.id)));

    return (
        <div className='pt-3 ps-2'>
            {onSaleProductIds.length > 0 &&
                <div className='fw-500 fs-32px font-poppins mt-2 pt-2 text-center text-uppercase'>On Sale</div>}
            <div className="container0">
                <div className="detail-wrapper">
                    <div className="releted-work pb-4">
                        {onSaleProductIds.length > 0 &&
                            <SwiperProductsPage swiperProducts={onSaleProductIds} className={'onsaleProducts'} />}
                    </div>
                </div>
            </div>
        </div>
    )
}
